:host {
  --host-icon-size: var(--icon-size, .8em);
  --host-icon-color: var(--icon-color, inherit);
  --host-icon-fill: var(--icon-fill, currentColor);
  --host-icon-stroke: var(--icon-stroke, currentColor);
  --host-icon-stroke-width: var(--icon-stroke-width, 1.5);

  display: inline-block;
  position: relative;
  width: var(--host-icon-size);
  height: var(--host-icon-size);
  color: var(--host-icon-color)
}


svg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: inherit;
  fill: var(--host-icon-fill);
  stroke: var(--host-icon-stroke);
  stroke-width: var(--host-icon-stroke-width);
  stroke-linejoin: round;
  stroke-linecap: round;
  filter: var(--icon-filter);
}
